import React from "react";
import { AriaAttributes, DOMAttributes, HTMLAttributes, ClassAttributes, DetailedHTMLProps } from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "./i18n";
import App from "./App";

ReactDOM.render(
  <App />,
  document.getElementById("app")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'dw-unifiedheader': DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;
      'my-media-main': DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}